import { useContext } from 'react';
import PreferencesContext from 'src/contexts/PreferencesContext';

const usePreferences = () => useContext(PreferencesContext);

export default usePreferences;
